/**
 * Server timestamp → this PC's clock, using the `serverNow` the server sent
 * with it. PC clocks can be seconds apart, so timers built from the raw
 * server (or another PC's) time disagree between judge and reader.
 */
export const toLocalTime = (
  serverTime: number | null | undefined,
  serverNow?: number | null,
): number | null => {
  if (!serverTime) return null;
  return serverNow ? serverTime + (Date.now() - serverNow) : serverTime;
};
